import getters from "./getters";
import mutations from "@/store/modules/sidebar/mutations";
import actions from "@/store/modules/sidebar/actions";

const state = {
  sidebarFull: true,
  activeMenu: 0,
  openChat: false,
  openCall: false,
  openOtherReason: false,
  powerUpsNotifications: 0,
};
export type State = typeof state;

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
